import React from "react";
import GlobalIcon from "../../components/GlobalIcon/GlobalIcon";

export const DEBOUNCE_MS = 300;

export const STRATEGY_OPTIONS = ["Batman", "Straddle", "Strangle", "Iron Condor"];

export const VALIDITY_OPTIONS = ["DAY", "IOC"];

export const DEFAULT_EXPIRY = "20-02-2026";

export const SelectDropdownIcon = (props) => (
  <GlobalIcon iconName="SelectDropdownArrow" {...props} />
);
